import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Importa os estilos do Tailwind
import App from './App';
import 'react-toastify/dist/ReactToastify.css'; // Importa os estilos das notificações

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

